// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b1676171","553":"012b98b0","977":"dc18a05c"}[chunkId] + ".chunk.js";
};